/** Extract nested property from given object.
 *  @param {string} path - Path to wanted property, separate by dot (.)
 *  @param {object} targetObject - Object that the property should be extracted from.
 */
export const extract = (targetObject: any, path: string): any => {
  return path
    .split('.')
    .reduce(
      (obj: any, key: string | number) => (obj && obj[key] ? obj[key] : undefined),
      targetObject
    );
};
